import { render, staticRenderFns } from "./AddReason.vue?vue&type=template&id=41cc6b26&"
import script from "./AddReason.vue?vue&type=script&lang=js&"
export * from "./AddReason.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports